import sample_1 from './sample1.jpeg';

export const dynamicIndustryImageKfz2Impressions = {
    sample_1,
};
